/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Helper
import * as CalendarUtility from './helpers/calendarUtility';

const styles = (theme) => ({
    monthWrapper: {
        display: 'inline-block',
    },
    monthBtn: {
        backgroundColor: '#d3e3f3',
        margin: '10px 5px 0 0',
        width: '90px',
        height: '90px',
        border: `1px solid ${theme.palette.colorDisabled}`,
        textAlign: 'center',
        cursor: 'pointer',
        fontSize: '12px',
        lineHeight: '22px',
        fontWeight: '500',
        textTransform: 'capitalize',
    },
    selectedMonthBtn: {
        backgroundColor: `${theme.palette.bgTile2} !important`,
        color: '#56b4e9',
    },
});

class MonthDatedCalendarView extends React.Component {
    showMonthCalendar = (monthDatedData) => {
        const { classes, isMonthActive, getSelectedMonthDetails } = this.props;
        return monthDatedData.map((data) => {
            const monthName = CalendarUtility.MonthsFull[data.month];
            const {
                day, year, month, calendarDateType, deliverySLA,
            } = data;
            const fullDate = new Date(year, month, day);
            const newMonth = (`0${(fullDate.getMonth() + 1)}`).slice(-2);
            const newDay = (`0${fullDate.getDate()}`).slice(-2);
            const newYear = fullDate.getFullYear();
            const newDate = [newYear, newMonth, newDay].join('-');

            return (
                <div className={classes.monthWrapper}>
                    <Button
                        key={`list-${month}`}
                        className={isMonthActive === newDate ? `${classes.monthBtn} ${classes.selectedMonthBtn}` : classes.monthBtn}
                        onClick={() => getSelectedMonthDetails(newDate, calendarDateType, deliverySLA)}
                    > {monthName} {year}
                    </Button>
                </div>
            );
        });
    };

    render() {
        const { monthDatedData } = this.props;
        return (
            <Grid>
                { this.showMonthCalendar(monthDatedData) }
            </Grid>
        );
    }
}

MonthDatedCalendarView.propTypes = {
    monthDatedData: PropTypes.array.isRequired,
    isMonthActive: PropTypes.string.isRequired,
    getSelectedMonthDetails: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MonthDatedCalendarView);
